import React, { useEffect, useRef, useState } from 'react';
import { XIcon } from 'lucide-react';
import { motion } from 'framer-motion';
import type { BrevoFormConfig } from '../data/brevoForms';
import { BrevoResultForm } from './BrevoResultForm';
import { WebinarInviteCard } from './WebinarInviteCard';
interface RegistrationModalProps {
  config: BrevoFormConfig;
  webinarUrl: string;
  onClose: () => void;
  onSuccess: () => void;
}
const EASE = [0.23, 1, 0.32, 1] as const;
export function RegistrationModal({
  config,
  webinarUrl,
  onClose,
  onSuccess
}: RegistrationModalProps) {
  const panelRef = useRef<HTMLDivElement>(null);
  const inviteRef = useRef<HTMLDivElement>(null);
  const [isRegistered, setIsRegistered] = useState(false);
  useEffect(() => {
    panelRef.current?.focus();
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    function handleKeyDown(event: KeyboardEvent) {
      if (event.key === 'Escape') onClose();
    }
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [onClose]);
  function handleSuccess() {
    setIsRegistered(true);
    onSuccess();
    window.setTimeout(() => {
      inviteRef.current?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }, 120);
  }
  return <div className="fixed inset-0 z-50 overflow-y-auto bg-noche/85 px-4 py-10" role="dialog" aria-modal="true" aria-label="Registro para recibir tu resultado" data-id="element-119" data-mp="hr5crmfss283">
      <motion.div ref={panelRef} tabIndex={-1} initial={{
      opacity: 0,
      scale: 0.96,
      y: 12
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} transition={{
      duration: 0.25,
      ease: EASE
    }} className="relative mx-auto w-full max-w-xl bg-hueso p-5 outline-none sm:p-8" data-id="element-120" data-mp="qrk535r6ihl3">
        <button type="button" onClick={onClose} aria-label="Cerrar" className="absolute right-3 top-3 rounded-sm p-2 text-noche/45 transition-colors duration-150 ease-out hover:text-violeta focus:outline-none focus-visible:ring-2 focus-visible:ring-violeta" data-id="element-121" data-mp="274r1domd3xuf">
          <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-122" data-mp="h0fcwgpwje0e" />
        </button>

        <p className="font-sans text-sm font-medium tracking-wide text-dorado-deep" data-id="element-123" data-mp="c2nc0x7a4hk2">
          Terminaste el test
        </p>
        <h2 className="mt-2 font-serif text-2xl leading-snug text-violeta sm:text-3xl" data-id="element-124" data-mp="3kj8m6hbndgor">
          Tu resultado está listo
        </h2>
        <p className="mt-3 font-sans text-base leading-relaxed text-noche/70" data-id="element-125" data-mp="3fh155dbynafk">
          Déjame tus datos y te lo envío completo a tu correo, junto con el primer paso para empezar
          a subir de nivel hoy mismo.
        </p>

        <div className="mt-6" data-id="element-126" data-mp="31rftko0hpxhk">
          <BrevoResultForm config={config} onSuccess={handleSuccess} data-id="element-127" data-mp="31qnyrfepw3sc" />
        </div>

        {isRegistered && <motion.div ref={inviteRef} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.25,
        ease: EASE
      }} className="mt-6" data-id="element-128" data-mp="2ws38o8t6j0hm">
            <WebinarInviteCard webinarUrl={webinarUrl} eyebrow="TU RESULTADO VA EN CAMINO" title="Ahora sí, no te vayas sin sumarte al webinar gratis" description="Tu resultado te dice en qué nivel estás. En el webinar en vivo te muestro cómo salir de ahí, paso a paso y sin costo." data-id="element-129" data-mp="1h353zxing0uy" />
          </motion.div>}
      </motion.div>
    </div>;
}